import React from "react";
import { Table } from 'react-bootstrap';

const NoMatches = () => <div className='text-center' style={{
  padding: '50px 0',
  fontSize: 30,
  color: '#ccc'
}}>No matches</div>

export class RecordsTable extends React.Component {
  render() {
    const { onRowClick } = this.props
    return (
      <div style={{ marginTop: 20 }}>
        {this.props.data && this.props.data.length > 0 ?
          <>
            <Table hover size="sm">
              <thead>
                <tr>
                  {this.props.columns.map((c, index) => <th key={index}>{c.header}</th>)}
                </tr>
              </thead>
              <tbody>
                {this.props.data && this.props.data.map((record, index) =>
                  <tr key={index} onClick={() => { if (onRowClick) onRowClick(record) }} style={{ cursor: onRowClick ? 'pointer' : 'auto' }}>
                    {this.props.columns.map((c, index) => {
                      if (c.field) return <td key={index}>{record[c.field]}</td>
                      if (c.render) return <td key={index}>{c.render(record)}</td>
                      return <></>
                    })}
                  </tr>)
                }
              </tbody>
            </Table>
            <div>{this.props.totalMatches} matches found</div>
          </> :
          <NoMatches></NoMatches>}

      </div>
    );
  }
}
